<!-- <footer class="container">
  <p class="float-right"> <a>Pashuposhan</a></p>
  <p>&copy; 2024- &copy;
    <a target="_blank" href="">averta</a>
  </p>
</footer> -->

<footer class="footer mt-auto py-3 text-light main-footer wf100" style="background-color: #004080;">
  <div class="container">
    <div class="row">
      <!-- Left Column -->
      <div class="col-md-4 mb-3">
        <div style="display: flex;">
          <img src="assets/images/goseva-logo.png" alt="Logo" style="width: 80px; margin-right: 10px;">
          <div style="color: white;">
            <strong>महाराष्ट्र गोसेवा आयोग</strong><br>
            <span>महाराष्ट्र शासन</span>
          </div>
        </div>
        <p class="mt-2">
          पशुसंवर्धन आयुक्तालय,<br>पहिला मजला, स्पायसर कॉलेज समोर, औंध-खडकी रोड, औंध, पुणे-411067</p>
        <!-- <p><i class="fas fa-map-marker-alt"></i> Pune Head Office Address:<br>
          पुणेप्रवाशाचं अहिल्यादेवी महाराष्ट्र मंडल व खोली विकास महामंडळ<br>
          वि. गोसलनगर, पुणे 411016</p> -->
        <!-- <p><i class="fa fa-envelope"></i> Email: mhgosevaayog&#64;gmail.com</p>
        <p><i class="fa fa-phone"></i> Call us: <br>020-25657112</p> -->

        <p>
          <i class="fa fa-envelope"></i>
          Email:
          <a href="mailto:mhgosevaayog@gmail.com">mhgosevaayog&#64;gmail.com</a>
        </p>
        <p>
          <i class="fa fa-phone"></i>
          Call us:
          <br>
          <a href="tel:02025657112">020-25657112</a>
        </p>

      </div>

      <!-- Middle Column -->
      <div class="col-md-4 mb-3">
        <h5>वेबसाइट लिंक्स</h5>
        <ul class="list-unstyled">
          <li><a routerLink="contact-us" routerLinkActive="active-link" class="text-light">संपर्क</a></li>
          <li><a routerLink="about-us" class="text-light">माहिती</a></li>
          <li><a routerLink="gallery" class="text-light">गॅलरी</a></li>
          <li><a routerLink="yojana-tapshil" class="text-light">योजना</a></li>
          <li><a href="https://dahd.maharashtra.gov.in/en/" class="text-light">dahd.maharashtra.gov.in</a></li>
        </ul>
      </div>

      <!-- Right Column -->
      <div class="col-md-4 mb-3">
        <h5>इतर लिंक्स</h5>
        <ul class="list-unstyled">
          <li><a href="https://www.youtube.com/playlist?list=PL477_1l-FMXVy6E-iGbvQ9_AQ5hbmr9zk" target="_blank" class="text-light">यूट्यूब व्हिडिओज</a></li>
          <li><a [href]="websiteUrl + 'privacypolicy'" target="_blank" class="text-light">Privacy Policy</a></li>
          <li><a routerLink="sitemap" routerLinkActive="active-link" class="text-light">Sitemap</a></li>
          <li><a href="https://www.mahagosevaayog.org/" class="text-light">mahagosevaayog.org</a></li>
          <!-- <h5 class="font-bold">Accessibility</h5>
          <ul class="list-inline">
            <li class="list-inline-item">
              <a class="cursor-pointer">Gray Scale</a> |
              <a class="cursor-pointer" (click)="toggleHighContrast()">High Contrast</a> |
              <span>Text Size:</span> &nbsp;&nbsp;
              <a class="cursor-pointer" id="btn-increase">A<sup>+</sup></a> &nbsp;&nbsp;
              <a class="cursor-pointer" id="btn-orig">A</a> &nbsp;&nbsp;
              <a class="cursor-pointer" id="btn-decrease">A<sup>-</sup></a>
            </li>
          </ul> -->
        </ul>
      </div>
    </div>
    <div class="text-center d-flex align-items-center">
      <p class="mb-0 w-100">&copy; Copyright 2024. All Rights Reserved. Site designed by Averta Strategy Pvt. Ltd.</p>
      &nbsp;
    </div>
  </div>
</footer>